import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden bg-brand-cream" data-id="element-35">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-36">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-brand-pink opacity-10 blur-3xl" data-id="element-37" />
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-brand-coral opacity-10 blur-3xl" data-id="element-38" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-39">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-40">
          <div className="w-full md:w-1/2 text-center md:text-left" data-id="element-41">
            <FadeIn data-id="element-42">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-brand-rose leading-tight mb-6" data-id="element-43">
                Borrón y Cuenta Nueva:{' '}
                <span className="text-brand-dark block mt-2" data-id="element-44">
                  El Sistema para Limpiar tu Crédito en USA por Ti Misma
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-45">
              <h2 className="text-lg md:text-xl text-gray-700 mb-4 font-medium leading-relaxed" data-id="element-46">
                Deja de ser rechazada por los bancos. Recupera tu puntaje y
                califica para tu casa o auto en 90 días o menos, sin pagar
                cientos de dólares a agencias que no cumplen.
              </h2>
              <p className="text-base md:text-lg text-brand-gold font-semibold mb-8" data-id="element-47">
                ⭐⭐⭐⭐⭐ Guía práctica y clara para comenzar a mejorar tu
                crédito en USA
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-48">
              <CTAButton className="w-full md:w-auto" data-id="element-49">
                ¡QUIERO MI CRÉDITO LIMPIO AHORA!
              </CTAButton>
              <div className="flex flex-col items-center md:items-start gap-1 mt-4 text-sm text-gray-500" data-id="element-50">
                <span data-id="element-51">🔒 Pago 100% seguro</span>
                <span data-id="element-52">💳 Acceso inmediato al comprar</span>
              </div>
            </FadeIn>
          </div>

          <div className="w-full md:w-1/2" data-id="element-53">
            <FadeIn direction="left" delay={0.3} data-id="element-54">
              <div className="relative" data-id="element-55">
                {/* Decorative frame behind image */}
                <div className="absolute inset-0 border-2 border-brand-gold transform translate-x-4 translate-y-4 rounded-lg z-0" data-id="element-56"></div>
                <img src="https://cdn.magicpatterns.com/uploads/cQk3ii3HWqAUrhLKSQHhmd/CREDITO_USA_ROSA.png" alt="Borrón y Cuenta Nueva Sistema" className="relative z-10 w-full rounded-lg shadow-2xl object-cover" data-id="element-57" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}